import { render, staticRenderFns } from "./DiscoveryCommentTable.vue?vue&type=template&id=4a737e6e&scoped=true"
import script from "./DiscoveryCommentTable.vue?vue&type=script&lang=ts"
export * from "./DiscoveryCommentTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a737e6e",
  null
  
)

export default component.exports